import gameAssets from "@themed-assets";
import ChevronRight from "@/src/assets/ChevronRight";
import useTourneyDetails from "@/src/hooks/utils/useTourneyDetails";
import React from "react";

function EventCard({
  isFlightParentTourney,
  parentTourneyName,
  parentTourney,
}) {
  const tourneyDetails = useTourneyDetails();
  return (
    <div className="bg-foreground rounded p-4 flex justify-between items-center">
      <div className="flex items-center">
        <div>
          <img
            src={
              isFlightParentTourney
                ? gameAssets.ParentTourneyStarIcon
                : gameAssets.EventStarIcon
            }
          />
        </div>
        {isFlightParentTourney ? (
          <div className="ml-3">
            <div className="text-xs text-secondary">
              Survivors From All Flights
            </div>
            <div className="text-xs text-secondary">
              will be auto registered to this event
            </div>
          </div>
        ) : (
          <div className="ml-3">
            <div className="text-xs text-secondary">Survivors Qualify For</div>
            <div className="text-gold-primary text-sm font-bold">
              {parentTourneyName}
            </div>
          </div>
        )}
      </div>
      {!isFlightParentTourney && parentTourney && (
        <div
          onClick={() =>
            tourneyDetails?.navigateToTourneyDetails(parentTourney)
          }
          className="flex items-center border-b pb-px border-success"
        >
          <div className="text-xs text-success font-medium mr-1">Details</div>
          <ChevronRight clr="#42be40" />
        </div>
      )}
    </div>
  );
}

export default EventCard;
